<template>
  <common-dialog
    ref="dialog"
    :title="originalData ? 'Update' : 'Create'"
    :inputs-map="formData"
    :input-value-change="valueChange"
    :save-cb="saveData"
    :reset-inputs="resetData"
  />
</template>
<script>
// others
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
export default {
  name: 'DialogEditOrCreate',
  mixins: [dialogMixin],
  props: {
    formInputInit: {
      type: Function,
      required: true
    }
  },
  components: {
    CommonDialog
  },
  data() {
    return {
      formData: [],
      originalData: null,
      saveDataCb: null
    }
  },
  methods: {
    saveData(form, done, error) {
      this.saveDataCb(form, done, error)
    },
    open(data, saveCb = null) {
      this.$set(this, 'originalData', data)
      this.resetData()
      this.$refs.dialog.resetErrors()
      this.$refs.dialog.open()
      this.saveDataCb = saveCb
    },
    valueChange() {},
    resetData() {
      this.$set(this, 'formData', this.formInputInit(this.originalData))
    },
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
